import React, { Component } from 'react'
import styled from 'styled-components'
import { Notification } from 'wix-style-react'

const NotificationWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
`

class NotificationController extends Component {
  static _sharedInstance = null

  constructor () {
    super()
    this.state = {
      notifications: []
    }
  }

  componentDidMount () {
    NotificationController._sharedInstance = this
  }

  componentWillUnmount () {
    NotificationController._sharedInstance = null
  }

  removeNotificatonFromListById = (id) => {
    const index = this.state.notifications.findIndex(i => i.id === id)

    if (index > -1) {
      const timeoutIndex = this.state.notifications[index].timeoutIndex
      const newNotifications = this.state.notifications.slice()

      newNotifications.splice(index, 1)

      this.setState({ notifications: newNotifications })
      clearTimeout(timeoutIndex)
    }
  }

  addNotification = ({text, type, timeoutMs}) => {
    const newId = Math.random().toString(36).substr(2, 5)
    const timeoutIndex = setTimeout(() => this.removeNotificatonFromListById(newId), timeoutMs)

    const newNotifications = this.state.notifications.slice()
    newNotifications.push({
      id: newId,
      type: type,
      text: text,
      timeoutIndex: timeoutIndex,
    })
    this.setState({
      notifications: newNotifications
    })
  }

  renderNotification = ({id, timeoutIndex, type, text}) => {
    return (
      <Notification
        onClose={() => this.removeNotificatonFromListById(id)}
        key={id}
        show
        size='big'
        theme={type}
        type='global'
        zIndex={10000}
      >
        <Notification.TextLabel>
          {text}
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    )
  }

  render () {
    return (
      <NotificationWrapper>
        {this.state.notifications.map(this.renderNotification)}
      </NotificationWrapper>
    )
  }
}

function displayStandard (text, timeoutMs = 5000) {
  if (!NotificationController._sharedInstance) {
    console.error('There is no mounted NotificationController component')
    return
  }

  NotificationController._sharedInstance.addNotification({
    text: text,
    type: 'standard',
    timeoutMs: timeoutMs,
  })
}

function displayError (text, timeoutMs = 5000) {
  if (!NotificationController._sharedInstance) {
    console.error('There is no mounted NotificationController component')
    return
  }

  NotificationController._sharedInstance.addNotification({
    text: text,
    type: 'error',
    timeoutMs: timeoutMs,
  })
}

function displayWarning (text, timeoutMs = 5000) {
  if (!NotificationController._sharedInstance) {
    console.error('There is no mounted NotificationController component')
    return
  }

  NotificationController._sharedInstance.addNotification({
    text: text,
    type: 'warning',
    timeoutMs: timeoutMs,
  })
}

function displaySuccess (text, timeoutMs = 5000) {
  if (!NotificationController._sharedInstance) {
    console.error('There is no mounted NotificationController component')
    return
  }

  NotificationController._sharedInstance.addNotification({
    text: text,
    type: 'success',
    timeoutMs: timeoutMs,
  })
}


export {displayStandard, displayError, displayWarning, displaySuccess}
export default NotificationController



// WEBPACK FOOTER //
// ./src/components/NotificationController.js